module.exports = __webpack_public_path__ + "static/media/yellow-bg.8adf3d8b.svg";